import * as actionTypes from '../actionTypes/fetchApi';

export const fetchApi = () => ({
  type: actionTypes.FETCH_API,
});

export const fetchApiFulfilled = payload => ({
  type: actionTypes.FETCH_API_FULFILLED,
  payload,
});

export const fetchApiRejected = payload => ({
  type: actionTypes.FETCH_API_REJECTED,
  payload,
});

export const setPointBenefitDataFromJunsi = payload => ({
  type: actionTypes.SET_POINT_BENEFIT_DATA_FROM_JUNSI,
  payload,
});

export const setPayDiscountDataFromJunsi = payload => ({
  type: actionTypes.SET_PAY_DISCOUNT_DATA_FROM_JUNSI,
  payload,
});

export const setPromotionBannerFromJunsi = payload => ({
  type: actionTypes.SET_PROMOTION_BANNER_FROM_JUNSI,
  payload,
});

export const setMetaCardDiscountDataFromJunsi = payload => ({
  type: actionTypes.SET_META_CARD_DISCOUNT_DATA_FROM_JUNSI,
  payload,
});